import { act } from '@ngrx/effects';
import { ORDER_LIST_ITEMS_PER_PAGE_LIST } from '../order-list/order-list.facade';
import { TOrderListActions } from './order-list.actions';
import { TOrderListActionType, TOrderListState } from './order-list.models';

export const initialState: TOrderListState = {
  orderListInfo: null,
  userPaginationOption: {
    pageNo: 1,
    pageSize: ORDER_LIST_ITEMS_PER_PAGE_LIST[0],
  },
  orderUploadDetailsInfo: null,
  orderToFactoriesAllocationInfo: null,
  orderListSelectedFilters: null,
  orderListViewType: 'TNA_COMPLETED',
};

export function orderListReducer(state = initialState, action: TOrderListActions): TOrderListState {
  switch (action.type) {
    case TOrderListActionType.GetOrderListSuccess:
      return {
        ...state,
        orderListInfo: action.OrderListRes,
      };
    case TOrderListActionType.SetUserPaginationOption:
      return {
        ...state,
        userPaginationOption: action.userPaginationOption,
      };
    case TOrderListActionType.GetOrderUploadDetailsSuccess:
      return {
        ...state,
        orderUploadDetailsInfo: action.orderUploadDetailsRes,
      };
    case TOrderListActionType.GetOrderToFactoriesSplit:
      return {
        ...state,
        orderToFactoriesAllocationInfo: null,
      };
    case TOrderListActionType.GetOrderToFactoriesSplitSuccess:
      return {
        ...state,
        orderToFactoriesAllocationInfo: action.orderToFactoriesRes,
      };
    case TOrderListActionType.ViewOrderFactoryAllocation:
      return {
        ...state,
        orderToFactoriesAllocationInfo: null,
      };
    case TOrderListActionType.ViewOrderFactoryAllocationSuccess:
      return {
        ...state,
        orderToFactoriesAllocationInfo: action.orderFactoryAllocationRes,
      };
    case TOrderListActionType.SetOrderListSelectedFilters:
      return {
        ...state,
        orderListSelectedFilters: action.filterModel,
      };
    case TOrderListActionType.SetOrderListBucketInfo:
      return {
        ...state,
        orderListViewType: action.viewType,
      };
    default:
      return state;
  }
}
